import { ReactElement } from "react";

import styles from "./index.module.css";
import { blur } from "../../../lib/dom";

export default function Dropdown(props: {
  label: string;
  selected: any;
  options: Array<{
    name: string;
    value: any;
    callback: () => void;
  }>;
}): ReactElement {
  return (
    <>
      <p className={styles.label}>{props.label}</p>

      <div className={styles.dropdownWrapper}>
        <select
          className={styles.dropdown}
          value={props.selected}
          onChange={({ target }) => {
            props.options[target.selectedIndex].callback();
            blur(target);
          }}
        >
          {props.options.map((option, i) => (
            <option key={i} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
